// extracted by mini-css-extract-plugin
module.exports = {"headwayNotification":"styles_headwayNotification__1_ii-","indicatorNew":"styles_indicatorNew__1C-nU","headwayWidget":"styles_headwayWidget__2MHAC","label":"styles_label__2FrMa"};